var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewsfeed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9577 2.83325C9.13768 2.83325 2.79102 9.17992 2.79102 16.9999C2.79102 24.8199 9.13768 31.1666 16.9577 31.1666C24.7777 31.1666 31.1243 24.8199 31.1243 16.9999C31.1243 9.17992 24.7918 2.83325 16.9577 2.83325ZM22.2702 17.4958L17.0002 23.4883L16.3768 24.1966C15.5127 25.1741 14.8043 24.9191 14.8043 23.6016V17.9916H12.396C11.3052 17.9916 11.0077 17.3258 11.7302 16.5041L17.0002 10.5116L17.6235 9.80325C18.4877 8.82575 19.196 9.08075 19.196 10.3983V16.0083H21.6043C22.6952 16.0083 22.9927 16.6741 22.2702 17.4958Z",
    fill: "#161F28"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsfeed);
export default __webpack_public_path__ + "static/media/newsfeed.dd9404938d170e056651ff42cc6b20a0.svg";
export { ForwardRef as ReactComponent };